export default __webpack_public_path__ + "static/photo-12-614ac001433638f48c2dca898d9cf5f1.jpg";